import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import GroupsIcon from '@mui/icons-material/Groups';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import ShareIcon from '@mui/icons-material/Share';

const UGCSection = () => {
  const theme = useTheme();
  const iconProps = { sx: { fontSize: 36, color: theme.palette.primary.main } };

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Contenido auténtico
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          ¿Qué es UGC y cómo será el contenido para Daka?
        </Box>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}
        >
          UGC (User Generated Content) es contenido creado por personas reales —usuarios, voceros o
          creadores— que muestran o hablan de un producto en uso. No es publicidad tradicional: es
          recomendación en primera persona que genera confianza y prueba social.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Box display="flex" justifyContent="center" marginBottom={1}>
              <GroupsIcon {...iconProps} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Quién lo crea
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Voceros de Daka, clientes reales o creadores aliados de TNO mostrando productos en su
              día a día: unboxing, uso en casa, comparativas o testimonios. El tono es cercano y
              creíble, no institucional.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Box display="flex" justifyContent="center" marginBottom={1}>
              <VideoLibraryIcon {...iconProps} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Formatos del contenido
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Cápsulas cortas para redes (Reels, Stories, TikToks), piezas para la señal de Radio
              Visual y material reutilizable para la web de Daka. Unboxing, demos en vivo, tips de
              uso y momentos “Sé feliz” con el producto.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Box display="flex" justifyContent="center" marginBottom={1}>
              <ShareIcon {...iconProps} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Dónde se publica
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Redes sociales de TNO Network, señal de Radio Visual 24/7 y, cuando aplique, canales de
              Daka. El mismo contenido trabaja en varios frentes para maximizar alcance y
              recordación.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UGCSection;
